'use client';
import { ProgressProvider } from '@bprogress/next/app';
// Colour set using CSS variables based on the layout
import './app-loading-provider.scss';
import { PropsWithChildren } from 'react';

/**
 * Loading bar shown while navigating between pages in the app
 */
export function AppLoadingProvider({ children }: PropsWithChildren) {
  return (
    <ProgressProvider
      delay={200}
      shallowRouting
      options={{ showSpinner: false }}
    >
      {children}
    </ProgressProvider>
  );
}
